import { createFeature } from '@ngrx/store';
import { accountWallReducer } from './account-wall.reducer';

export const accountWallFeature = createFeature({
  name: 'accountWall',
  reducer: accountWallReducer,
});
